import Light from 'elem/SVGIcon/PowerBackup/Light';
import Phone from 'elem/SVGIcon/PowerBackup/Phone';
import Projector from 'elem/SVGIcon/OutdoorRecreation/Projector';
import Refrigerator from 'elem/SVGIcon/PowerBackup/Refrigerator';
import CoffeeMaker from 'elem/SVGIcon/PowerBackup/CoffeeMaker';
import ElectricGrill from 'elem/SVGIcon/OutdoorRecreation/ElectricGrill';
// import EFPicture from 'elem/compCommon/EFPicture';
import EcoImg from 'eco-design/base/eco-img';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar } from 'swiper';
import CarFridge from '@elem/SVGIcon/VanlifeRoadtrips/CarFridge';
import Microwave from '@elem/SVGIcon/PowerBackup/Microwave';
import AirConditioner from '@elem/SVGIcon/PowerBackup/AirConditioner';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useUsCaConfig } from './us_ca.config';

export default function F({ callBuy }: any) {
    const { useLang, useState, useEffect, useRouter, Link } = useGlobal();
    const { t } = useLang('vanliferoadtrips');
    const { locale } = useRouter();
    const [gap, setGap] = useState(24);
    const [open, setOpen] = useState(false);
    const ZA_SITE: string[] = ['za'];
    const EU_SITE: string[] = ['eu', 'uk', 'es', 'it'];
    const EUS_SITE: string[] = ['eu', 'uk', 'de', 'it', 'es', 'fr'];

    const cards2tag: any = {
        za: '',
        us: t('common_card_tag_new_arrival'),
        au: t('common_card_tag_best_seller'),
    };
    const deltapro_img: any = {
        us: '',
        uk: '_uk',
        au: '_au',
        za: '_za',
        eu: '_eu',
        de: '_eu',
        fr: '_eu',
        it: '_eu',
        es: '_eu',
        kr: '_eu',
    };

    let AC_DELTA = [
        {
            isActive: true,
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718853522639/delta2_AC.png',
            title: 'DELTA 2',
            question: 'secF_card4_sub1_question',
            content: 'secF_card4_sub1_content',
            productId: (() => {
                const localMap: any = {
                    us: '7049853632585',
                    ca: '8132015980698',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41064248868937',
                    ca: '44676925391002',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            isActive: false,
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718853566613/delta2max_AC.png',
            title: 'DELTA 2 Max',
            question: 'secF_card4_sub2_question',
            content: 'secF_card4_sub2_content',
            productId: (() => {
                const localMap: any = {
                    us: '7049853632585',
                    ca: '8132015980698',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41064248934473',
                    ca: '44676925456538',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            isActive: false,
            title: 'DELTA Pro',
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718853698397/deltapro_AC1.png',
            question: 'secF_card4_sub3_question',
            content: 'secF_card4_sub3_content',
            productId: (() => {
                const localMap: any = {
                    us: '7049853632585',
                    ca: '8132015980698',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41064248901705',
                    ca: '44676925423770',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
    ];

    if (['us', 'ca'].includes(locale)) {
        AC_DELTA = [
            AC_DELTA[1],
            AC_DELTA[0],
            {
                isActive: false,
                img: '',
                title: 'DELTA 3 Plus',
                question: 'secF_card4_sub4_question',
                content: 'secF_card4_sub4_content',
                productId: (() => {
                    const localMap: any = {
                        us: '7289136054345',
                        ca: '8331157766298',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-3-plus-portable-power-station?variant=41826183249993',
                        ca: 'https://ca.ecoflow.com/products/delta-3-plus-portable-power-station?variant=51645141025139',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '41826183249993',
                        ca: '51645141025139',
                    };
                    return localMap[locale] || localMap.us;
                })(),
            },
            AC_DELTA[2],
        ];
    }

    const [acDelta, setACDelta] = useState(AC_DELTA);

    const cardAC = [
        {
            id: 'AC',
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718853522639/delta2_AC.png',
            title: 'EcoFlow Alternator Charger',
            cartTitle: 'EcoFlow Alternator Charger + DELTA 2',
            power: '800W｜ 8× Faster Charging ｜ Plug-&-Play',
            question: 'secF_card4_sub1_question',
            content: 'secF_card4_sub1_content',
            descArr: ['Charge 1kWh on a 1.3-hour drive', 'FREE energy with every minute driving', '3-in-1 fast charger, maintainer, and battery booster'],
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/800w-alternator-charger',
                    ca: 'https://ca.ecoflow.com/products/800w-alternator-charger',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7049853632585',
                    ca: '8132015980698',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41064248868937',
                    ca: '44676925391002',
                };
                return localMap[locale] || localMap.us;
            })(),
            children: JSON.parse(JSON.stringify([...acDelta])),
        },
    ];

    const [productAC, setProductAC] = useState(cardAC);

    let cards: any = [
        {
            img: `/responsive/picture/common-products/deltapro${deltapro_img[locale] || deltapro_img.us}.png`,
            power: t('secF_card1_power'),
            title: t('secF_card1_title'),
            tag: ['au'].includes(locale) ? '' : t('common_card_tag_recommended'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-pro-portable-power-station',
                    ca: 'https://ca.ecoflow.com/products/delta-pro-portable-power-station',
                    de: 'https://de.ecoflow.com/products/delta-pro-portable-power-station',
                    za: 'https://za.ecoflow.com/products/delta-pro-portable-power-station',
                    fr: 'https://fr.ecoflow.com/products/delta-pro-portable-power-station',
                    eu: 'https://eu.ecoflow.com/products/delta-pro-portable-power-station',
                    uk: 'https://uk.ecoflow.com/products/delta-pro-portable-power-station',
                    it: 'https://it.ecoflow.com/products/delta-pro-portable-power-station',
                    es: 'https://es.ecoflow.com/products/delta-pro-portable-power-station',
                    au: 'https://au.ecoflow.com/products/delta-pro-portable-power-station',
                    kr: 'https://kr.ecoflow.com/products/delta-pro-portable-power-station',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6585086836809',
                    ca: '6944959824026',
                    de: '7530381967607',
                    za: '7027758137553',
                    fr: '7607012983010',
                    eu: '6939282047140',
                    uk: '6827735941312',
                    it: '7709728047345',
                    es: '7693954285790',
                    au: '7220911505606',
                    kr: '7429923635369',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40516140138569',
                    ca: '43725958873242',
                    de: '46769077453135',
                    za: '41601871610065',
                    fr: '46853508596059',
                    eu: '46819486892375',
                    uk: '46755685368147',
                    it: '47110131286365',
                    es: '46852983947611',
                    au: '42736222142662',
                    kr: '43452185411753',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secF_card1_desc1'), t('secF_card1_desc2'), t('secF_card1_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secF_card1_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secF_card1_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon2_desc'),
                },
                {
                    icon: ['au', 'za', ...EU_SITE].includes(locale) ? <CarFridge className="card-icon" /> : <Projector className="card-icon" />,
                    title: t.rich('secF_card1_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon3_desc'),
                },
                {
                    icon: ['au', 'za', ...EU_SITE].includes(locale) ? <CoffeeMaker className="card-icon" /> : <Refrigerator className="card-icon" />,
                    title: t.rich('secF_card1_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon4_desc'),
                },
                {
                    icon: ['au', 'za', ...EU_SITE].includes(locale) ? <Microwave className="card-icon" /> : <CoffeeMaker className="card-icon" />,
                    title: t.rich('secF_card1_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon5_desc'),
                },
                {
                    icon: ['au', 'za', ...EU_SITE].includes(locale) ? <AirConditioner className="card-icon" /> : <ElectricGrill className="card-icon" />,
                    title: t.rich('secF_card1_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon6_desc'),
                },
            ],
        },
        {
            img: `/responsive/picture/common-products/delta${ZA_SITE.includes(locale) ? '' : '2'}max.png`,
            power: t('secF_card2_power'),
            title: t('secF_card2_title'),
            tag: cards2tag[locale] || cards2tag.us,
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-2-max-portable-power-station',
                    ca: 'https://ca.ecoflow.com/products/delta-2-max-portable-power-station',
                    de: 'https://de.ecoflow.com/products/delta-2-max-portable-power-station',
                    za: 'https://za.ecoflow.com/products/delta-max-portable-power-station',
                    fr: 'https://fr.ecoflow.com/products/delta-2-max-portable-power-station',
                    eu: 'https://eu.ecoflow.com/products/delta-2-max-portable-power-station',
                    uk: 'https://uk.ecoflow.com/products/delta-2-max-portable-power-station',
                    it: 'https://it.ecoflow.com/products/delta-2-max-portable-power-station',
                    es: 'https://es.ecoflow.com/products/delta-2-max-portable-power-station',
                    au: 'https://au.ecoflow.com/products/delta-max-portable-power-station',
                    kr: 'https://kr.ecoflow.com/products/delta-max-2000-portable-power-station',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6905537888329',
                    ca: '7825964400794',
                    de: '8513034813775',
                    za: '7027758235857',
                    fr: '8431233794395',
                    eu: '8414996627799',
                    uk: '8416984367443',
                    it: '8415773360477',
                    es: '8435033899355',
                    au: '6837457256646',
                    kr: '7651423125673',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40538145095753',
                    ca: '43592212775066',
                    de: '46739567706447',
                    za: '41620506902737',
                    fr: '46793751789915',
                    eu: '46790633881943',
                    uk: '46679851139411',
                    it: '46891073274205',
                    es: '46787970269531',
                    au: '41762129117382',
                    kr: '43452330999977',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secF_card2_desc1'), t('secF_card2_desc2'), t('secF_card2_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secF_card2_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secF_card2_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon2_desc'),
                },
                {
                    icon: ['za', ...EU_SITE].includes(locale) ? <CarFridge className="card-icon" /> : <Projector className="card-icon" />,
                    title: t.rich('secF_card2_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon3_desc'),
                },
                {
                    icon: ['za', ...EU_SITE].includes(locale) ? <CoffeeMaker className="card-icon" /> : <Refrigerator className="card-icon" />,
                    title: t.rich('secF_card2_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon4_desc'),
                },
                {
                    icon: ['za', ...EU_SITE].includes(locale) ? <Microwave className="card-icon" /> : <CoffeeMaker className="card-icon" />,
                    title: t.rich('secF_card2_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon5_desc'),
                },
                {
                    icon: ['za', ...EU_SITE].includes(locale) ? <AirConditioner className="card-icon" /> : <ElectricGrill className="card-icon" />,
                    title: t.rich('secF_card2_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon6_desc'),
                },
            ],
        },
        {
            img: '/responsive/picture/common-products/delta2.png',
            power: t('secF_card3_power'),
            title: t('secF_card3_title'),
            tag: ['au'].includes(locale) ? t('common_card_tag_recommended') : t('common_card_tag_best_seller'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-2-portable-power-station',
                    ca: 'https://ca.ecoflow.com/products/delta-2-portable-power-station',
                    de: 'https://de.ecoflow.com/products/delta-2-portable-power-station',
                    za: 'https://za.ecoflow.com/products/delta-2-portable-power-station',
                    fr: 'https://fr.ecoflow.com/products/delta-2-portable-power-station',
                    eu: 'https://eu.ecoflow.com/products/delta-2-portable-power-station',
                    uk: 'https://uk.ecoflow.com/products/delta-2-portable-power-station',
                    it: 'https://it.ecoflow.com/products/delta-2-portable-power-station',
                    es: 'https://es.ecoflow.com/products/delta-2-portable-power-station',
                    au: 'https://au.ecoflow.com/collections/new-product-launch/products/delta-2-portable-power-station',
                    kr: 'https://kr.ecoflow.com/products/delta-2-portable-power-station',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6806217719881',
                    ca: '7440912384154',
                    de: '7742214308087',
                    za: '7187057803473',
                    fr: '7838178017506',
                    eu: '7403706253476',
                    uk: '7335539867840',
                    it: '7778985246961',
                    es: '7766079799518',
                    au: '7756517146822',
                    kr: '7633244225705',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40569176326217',
                    ca: '43725896056986',
                    de: '43148797739255',
                    za: '41620506575057',
                    fr: '43231886704866',
                    eu: '42596003512484',
                    uk: '43099247608000',
                    it: '43166053925105',
                    es: '43293121380574',
                    au: '42768126181574',
                    kr: '43452336144553',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secF_card3_desc1'), t('secF_card3_desc2'), t('secF_card3_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secF_card3_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secF_card3_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon2_desc'),
                },
                {
                    icon: ['au', 'za', ...EU_SITE].includes(locale) ? <CarFridge className="card-icon" /> : <Projector className="card-icon" />,
                    title: t.rich('secF_card3_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon3_desc'),
                },
                {
                    icon: ['au', 'za', ...EU_SITE].includes(locale) ? <CoffeeMaker className="card-icon" /> : <Refrigerator className="card-icon" />,
                    title: t.rich('secF_card3_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon4_desc'),
                },
                {
                    icon: ['au', 'za', ...EU_SITE].includes(locale) ? <Microwave className="card-icon" /> : <CoffeeMaker className="card-icon" />,
                    title: t.rich('secF_card3_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon5_desc'),
                },
                {
                    icon: ['za', 'au', ...EU_SITE].includes(locale) ? <AirConditioner className="card-icon" /> : <ElectricGrill className="card-icon" />,
                    title: t.rich('secF_card3_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon6_desc'),
                },
            ],
        },
    ];

    const { cards: cards2, euCards } = useUsCaConfig(locale);

    if (['us', 'ca'].includes(locale)) {
        cards = cards2;
    } else if (EUS_SITE.includes(locale)) {
        cards = euCards;
    }

    if (locale === 'au') {
        cards = [
            {
                img: '/responsive/picture/common-products/delta2.png',
                power: t('secF_card3_power'),
                title: t('secF_card3_title'),
                tag: t('common_card_tag_recommended'),
                link_more: 'https://au.ecoflow.com/collections/new-product-launch/products/delta-2-portable-power-station',
                productId: '7756517146822',
                variantId: '42768126181574',
                descArr: [t('secF_card3_desc1'), t('secF_card3_desc2'), t('secF_card3_desc3')],
                iconArr: [
                    {
                        icon: <Light className="card-icon" />,
                        title: t.rich('secF_card3_icon1_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card3_icon1_desc'),
                    },
                    {
                        icon: <Phone className="card-icon" />,
                        title: t.rich('secF_card3_icon2_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card3_icon2_desc'),
                    },
                    {
                        icon: <CarFridge className="card-icon" />,
                        title: t.rich('secF_card3_icon3_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card3_icon3_desc'),
                    },
                    {
                        icon: <CoffeeMaker className="card-icon" />,
                        title: t.rich('secF_card3_icon4_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card3_icon4_desc'),
                    },
                    {
                        icon: <Microwave className="card-icon" />,
                        title: t.rich('secF_card3_icon5_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card3_icon5_desc'),
                    },
                    {
                        icon: <AirConditioner className="card-icon" />,
                        title: t.rich('secF_card3_icon6_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card3_icon6_desc'),
                    },
                ],
            },
            {
                img: `/responsive/picture/common-products/deltamax.png`,
                power: t('secF_card2_power'),
                title: t('secF_card2_title'),
                tag: cards2tag[locale] || cards2tag.us,
                link_more: 'https://au.ecoflow.com/products/delta-max-portable-power-station',
                productId: '6837457256646',
                variantId: '41762129117382',
                descArr: [t('secF_card2_desc1'), t('secF_card2_desc2'), t('secF_card2_desc3')],
                iconArr: [
                    {
                        icon: <Light className="card-icon" />,
                        title: t.rich('secF_card2_icon1_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card2_icon1_desc'),
                    },
                    {
                        icon: <Phone className="card-icon" />,
                        title: t.rich('secF_card2_icon2_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card2_icon2_desc'),
                    },
                    {
                        icon: <Projector className="card-icon" />,
                        title: t.rich('secF_card2_icon3_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card2_icon3_desc'),
                    },
                    {
                        icon: <Refrigerator className="card-icon" />,
                        title: t.rich('secF_card2_icon4_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card2_icon4_desc'),
                    },
                    {
                        icon: <CoffeeMaker className="card-icon" />,
                        title: t.rich('secF_card2_icon5_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card2_icon5_desc'),
                    },
                    {
                        icon: <ElectricGrill className="card-icon" />,
                        title: t.rich('secF_card2_icon6_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card2_icon6_desc'),
                    },
                ],
            },
            {
                img: `/responsive/picture/common-products/delta2max.png`,
                power: t('secF_card4_power'),
                title: t('secF_card4_title'),
                tag: t('common_card_tag_new_arrival'),
                link_more: 'https://au.ecoflow.com/products/delta-2-max-portable-power-station',
                productId: '7914502422726',
                variantId: '43045698371782',
                descArr: [t('secF_card4_desc1'), t('secF_card4_desc2'), t('secF_card4_desc3')],
                iconArr: [
                    {
                        icon: <Light className="card-icon" />,
                        title: t.rich('secF_card4_icon1_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card4_icon1_desc'),
                    },
                    {
                        icon: <Phone className="card-icon" />,
                        title: t.rich('secF_card4_icon2_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card4_icon2_desc'),
                    },
                    {
                        icon: <Refrigerator className="card-icon" />,
                        title: t.rich('secF_card4_icon3_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card4_icon3_desc'),
                    },
                    {
                        icon: <CoffeeMaker className="card-icon" />,
                        title: t.rich('secF_card4_icon4_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card4_icon4_desc'),
                    },
                    {
                        icon: <Microwave className="card-icon" />,
                        title: t.rich('secF_card4_icon5_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card4_icon5_desc'),
                    },
                    {
                        icon: <AirConditioner className="card-icon" />,
                        title: t.rich('secF_card4_icon6_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card4_icon6_desc'),
                    },
                ],
            },
            {
                img: `/responsive/picture/common-products/deltapro${deltapro_img[locale] || deltapro_img.us}.png`,
                power: t('secF_card1_power'),
                title: t('secF_card1_title'),
                link_more: 'https://au.ecoflow.com/products/delta-pro-portable-power-station',
                productId: '7220911505606',
                variantId: '42736222142662',
                descArr: [t('secF_card1_desc1'), t('secF_card1_desc2'), t('secF_card1_desc3')],
                iconArr: [
                    {
                        icon: <Light className="card-icon" />,
                        title: t.rich('secF_card1_icon1_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card1_icon1_desc'),
                    },
                    {
                        icon: <Phone className="card-icon" />,
                        title: t.rich('secF_card1_icon2_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card1_icon2_desc'),
                    },
                    {
                        icon: <CarFridge className="card-icon" />,
                        title: t.rich('secF_card1_icon3_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card1_icon3_desc'),
                    },
                    {
                        icon: <CoffeeMaker className="card-icon" />,
                        title: t.rich('secF_card1_icon4_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card1_icon4_desc'),
                    },
                    {
                        icon: <Microwave className="card-icon" />,
                        title: t.rich('secF_card1_icon5_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card1_icon5_desc'),
                    },
                    {
                        icon: <AirConditioner className="card-icon" />,
                        title: t.rich('secF_card1_icon6_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card1_icon6_desc'),
                    },
                ],
            },
        ];
    }
    const [cardLists, setCardLists] = useState(cards);

    const handleBuy = (card: any) => {
        try {
            // @ts-ignore
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {
            callBuy({
                discountPrice: card?.discountPrice,
                originalPrice: card?.originalPrice,
                inventory: card?.inventory,
                productId: card?.productId,
                variantId: card?.variantId,
                img: card?.img,
                title: card?.id === 'AC' ? card?.cartTitle : card?.title,
            });
        }
    };

    const handleChangBundle = (m: any) => {
        const tmpACDelta = JSON.parse(JSON.stringify(acDelta));
        const bundle = tmpACDelta[m];
        if (bundle?.isActive) return;
        tmpACDelta?.map((item: any, k: number) => (item.isActive = k === m));
        setACDelta(tmpACDelta);
        const tempArr = JSON.parse(JSON.stringify(productAC));
        tempArr?.map((card: any, index) => {
            card?.children?.map((child: any) => {
                const isTarget = child?.variantId === bundle?.variantId;
                child.isActive = isTarget;
                if (isTarget) {
                    card.productId = bundle?.productId;
                    card.variantId = bundle?.variantId;
                    card.question = bundle?.question;
                    card.content = bundle?.content;
                    card.inventory = bundle?.inventory;
                    card.discountPrice = bundle?.discountPrice;
                    card.originalPrice = bundle?.originalPrice;
                    card.img = bundle?.img;
                    card.cartTitle = card?.title + ' + ' + bundle?.title;
                    if (bundle.link_more) {
                        card.link_more = bundle.link_more;
                    } else {
                        card.link_more = cardAC[0].link_more;
                    }
                }
            });
        });
        setProductAC(tempArr);
    };

    const getAsynItem = async (item: any) => {
        const { productId, variantId } = item;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    item.discountPrice = res?.data?.price;
                    item.originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                    // item.inventory = res?.data?.inventoryQuantity ?? undefined;
                    item.inventory = res?.data?.inventoryPolicy === 'continue' ? 9999 : res?.data?.inventoryQuantity ?? undefined;
                    // item.inventory = 1;
                    item.link_buy = `https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`;
                    if (!item.img && res?.data?.variantImg) {
                        item.img = res?.data?.variantImg;
                    }
                    if (!item?.title && (res?.data?.productTitle || res?.data?.skuTitle)) {
                        item.title = res?.data?.skuTitle || res?.data?.productTitle;
                    }
                    if (!item?.cartTitle && (res?.data?.productTitle || res?.data?.skuTitle)) {
                        item.cartTitle = res?.data?.skuTitle || res?.data?.productTitle;
                    }
                    return resolve(res);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, []);

    useEffect(() => {
        const tempArr = [...cards];
        const promises = tempArr?.map((item: any, k: number) => getAsynItem(item));
        Promise.all(promises)
            .then(() => {
                setCardLists(tempArr?.filter((list: any) => list?.inventory !== undefined));
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    useEffect(() => {
        const tempArr = JSON.parse(JSON.stringify([...acDelta]));
        const promises = tempArr?.map((item: any, k: number) => getAsynItem(item));
        Promise.all(promises)
            .then(() => {
                setACDelta(tempArr?.filter((list: any) => list?.inventory !== undefined));
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    useEffect(() => {
        const tempArr = JSON.parse(JSON.stringify(productAC));
        const promises = tempArr?.map((item: any, k: number) => getAsynItem(item));
        Promise.all(promises)
            .then(() => {
                setProductAC(tempArr?.filter((list: any) => list?.inventory !== undefined));
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    return (
        <div id="vanlife-roadtrips-F" className={`vanlife-roadtrips-F ${css['vanlife-roadtrips-F']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secF_title')}</p>
                </div>
                <Swiper
                    className="cards swiper-box"
                    effect="fade"
                    modules={[Scrollbar]}
                    spaceBetween={gap}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                >
                    {cardLists?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                            {card?.tag && <span className="card-tag">{card?.tag}</span>}
                            {/* <EFPicture src={card?.img} alt={card?.title} /> */}
                            <EcoImg className="ef-picture" pc={card?.img} />
                            <div className="box-1">
                                <div className="box-2">
                                    <p className="card-power">{card?.power}</p>
                                    <p className="card-title">{card?.title}</p>
                                    <ul className="card-descs">
                                        {card?.descArr?.map((desc: any, m: number) => (
                                            <li className="card-desc" key={`${k}_${m}`}>
                                                {desc}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="box-3">
                                    <ul className={`card-icons${open ? ' open' : ''}`}>
                                        {card?.iconArr?.map((icon: any, n: number) => (
                                            <li className="card-icon-item" key={`${k}_${n}`}>
                                                {icon?.icon}
                                                <p className="icon-title">{icon?.title}</p>
                                                <p className="icon-desc">{icon?.desc}</p>
                                            </li>
                                        ))}
                                    </ul>
                                    {!open && (
                                        <span className="card-arrow" onClick={() => setOpen(true)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5" fill="none">
                                                <path d="M1.5 1L4.5 4L7.5 1" stroke="#AEAEAE" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </span>
                                    )}
                                    <div className="card-btns">
                                        {card?.link_buy && (
                                            <>
                                                {Number(card?.inventory) <= 0 ? (
                                                    <button disabled className={`btn-buy card-btn disable`}>
                                                        {t('common_card_out')}
                                                    </button>
                                                ) : (
                                                    <p className={`btn-buy card-btn`} onClick={() => handleBuy(card)}>
                                                        {t('common_card_buy')}
                                                    </p>
                                                )}
                                            </>
                                        )}
                                        {card?.link_more && (
                                            <Link
                                                className="btn-more card-btn"
                                                href={
                                                    ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale)
                                                        ? card?.link_more
                                                        : `${card?.link_more}${
                                                              String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                                          }utm_source=scenario+page&utm_medium=Pillar`
                                                }
                                                target="_blank"
                                                dataLayer={{
                                                    event: 'uaEvent',
                                                    event_name: 'select_product',
                                                    list_name: t('secF_title'),
                                                    product_name: card.title,
                                                    button_name: t('common_card_more'),
                                                }}
                                            >
                                                {t('common_card_more')}
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                {['us', 'ca'].includes(locale) && (
                    <div className="img-box">
                        <EFPicture
                            src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718854007282/PC%2Blaptop-.jpg"
                            srcPad="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718854042408/ipad%2Bmobile-.jpg"
                            srcMobile="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718854042408/ipad%2Bmobile-.jpg"
                            alt={'Charge 1kWh on a 1.3-hour drive'}
                        />
                        <div className="img-info">
                            <p className="img-title">{'Charge 1kWh on a 1.3-hour drive'}</p>
                            <p className="img-desc">
                                {
                                    'Paired with EcoFlow 800W Alternator Charger\nFREE Energy with Every Minute Driving\n3-in-1 Fast Charger, Maintainer, and Battery Booster\n8× Faster than Traditional Car Chargers'
                                }
                            </p>
                        </div>
                    </div>
                )}
                <ul className="products">
                    {productAC?.map((p: any, k: number) => (
                        <li className="product" key={k}>
                            <div className="p-img">
                                <EFPicture src={p.img} alt={p.title} />
                            </div>
                            <div className="p-info">
                                <p className="p-power">{p.power}</p>
                                <p className="p-title">{p.title}</p>
                                <ul className="p-descs">
                                    {p.descArr?.map((d: any, m: number) => (
                                        <li className="p-desc" key={k + '_' + m}>
                                            {d}
                                        </li>
                                    ))}
                                </ul>
                                <p className="p-question">{t(p.question)}</p>
                                <p className="p-content">
                                    {t.rich(p.content, {
                                        b: (tx: string) => <span className="b">{tx}</span>,
                                    })}
                                </p>
                                <ul className="subs">
                                    {p.children?.map((child: any, m: number) => (
                                        <li className={`sub ${child?.isActive ? 'active' : ''}`} key={k + '_' + m} onClick={() => handleChangBundle(m)}>
                                            {child?.title}
                                        </li>
                                    ))}
                                </ul>
                                <div className="card-btns">
                                    {p?.link_buy && (
                                        <>
                                            {Number(p?.inventory) <= 0 ? (
                                                <button disabled className={`btn-buy card-btn disable`}>
                                                    {t('common_card_out')}
                                                </button>
                                            ) : (
                                                <p className={`btn-buy card-btn`} onClick={() => handleBuy(p)}>
                                                    {t('common_card_buy')}
                                                </p>
                                            )}
                                        </>
                                    )}
                                    {p?.link_more && (
                                        <Link
                                            className="btn-more card-btn"
                                            href={`${p?.link_more + '?variant=' + p.variantId}${
                                                String(p?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                            }utm_source=scenario+page&utm_medium=Pillar`}
                                            target="_blank"
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'select_product',
                                                list_name: t('secF_title'),
                                                product_name: p.title,
                                                button_name: t('common_card_more'),
                                            }}
                                        >
                                            {t('common_card_more')}
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
